module.exports = "<app-limit-flow-proposal \r\n    [accountClientID]=\"accountClientID\" \r\n    [tempGroup]=\"tempGroup\" \r\n    [profileUser]=\"profileUser\" \r\n    [currentClientDocument]=\"currentClientDocument\"\r\n    [proposalIDclosed]=\"proposalIDclosed\"\r\n    [segmentoID]=\"segmentoID\"\r\n    class=\"\">\r\n</app-limit-flow-proposal>"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/proposal-view-modal/LCproposal-view/lc-proposal-view.component.html
// module id = ./src/app/account-client/component/account-client-details/proposal-view-modal/LCproposal-view/lc-proposal-view.component.html
// module chunks = main